const generalDataRoute = {
	name: 'general-data',
	path: 'general-data',
	meta: {
		title: 'Datos Generales',
	},
	component: () => import('@/pages/configuration/general-data'),
};

export default generalDataRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/generalData/index.js